import { styled } from "@mui/material/styles";
import ListItemIcon from "@mui/material/ListItemIcon";

const SideBarListItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>(({ theme, open }) => ({
  minWidth: 0,
  justifyContent: "center",
  marginRight: open ? theme.spacing(3) : "auto",
  color: "inherit",
}));

export default SideBarListItemIcon;
